<div class="video-background" [hidden]="!viewInstructionalVideo"></div>
<div class="videogular-container" [hidden]="!viewInstructionalVideo">
  <vg-player
    class="video-container"
    (onPlayerReady)="onPlayerReady($event)"
    (dblclick)="skipVideo($event)"
    *ngIf="videoSource"
  >
    <video
      [src]="videoSource"
      [vgMedia]="$any(videoPlayerElement)"
      #videoPlayerElement
      id="singleVideo"
      preload="auto"
      playsinline
    >
    </video>
    @if (requiresManualPlay) {
      <img
        class="video-overlay"
        alt="Play Video"
        src="/assets/images/buttons/playBttn_bu.svg"
        (click)="manuallyPlayVideo()"
      />
    }
  </vg-player>
</div>
